import styled, { css } from 'styled-components'

export const ProfileTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #555;
`

export const Wrapper = styled.div``

export const CardWrapper = styled.div`
  @media (min-width: 1170px) {
    .col-6 {
      width: 50%;
    }
  }
`

export const CardBox = styled.div`
  padding: 16px;
  margin-bottom: 8px;
  height: 100px;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  cursor: pointer;

  border: 1px solid #e5e5e5;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

  .iconCredit {
    display: flex;
    align-items: center;
    margin-left: 28px;
  }
`

export const CardInfo = styled.div`
  justify-self: left;
  font-size: 14px;
  margin-left: 16px;
  margin-right: 8px;
  width: 240px;
  flex: 1;

  p > p {
    color: #707070;
  }
  strong {
    font-weight: 600;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    margin-left: 8px;
  }
`
